import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("imi_token");
    if (!token) { setUser(false); setReady(true); return; }
    let cancelled = false;
    const check = async (attempt = 1) => {
      try {
        const r = await api.get("/auth/me", { timeout: 15000 });
        if (!cancelled) { setUser(r.data); setReady(true); }
      } catch (e) {
        const st = e.response?.status;
        if (st === 401 || st === 403) {
          // Token really is invalid/expired — sign out
          localStorage.removeItem("imi_token");
          if (!cancelled) { setUser(false); setReady(true); }
          return;
        }
        // Transient (server restarting / deploy / network) — retry, keep the token
        if (attempt < 4) { setTimeout(() => check(attempt + 1), 2000 * attempt); return; }
        if (!cancelled) { setUser(false); setReady(true); }
      }
    };
    check();
    return () => { cancelled = true; };
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("imi_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("imi_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
